import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { InterceptorHttpParams } from '../../../domain/interceptor.model';
import { SystemUser } from '../../../domain/user.model';
import { GenericService } from './generic.service';

@Injectable()
export class UserService extends GenericService {
    constructor(private store: Store,
                private http: HttpClient) {
        super(store);
    }

    login(username: string, password: string) {
        return this.http.post<SystemUser>(`/api/user/login`, {username, password})
            .pipe(catchError(this.errorsMain), tap(this.cleanMain));
    }

    logout() {
        return this.http.get<any>(`/api/user/logout`);
    }

    remindPassword(username: string) {
        return this.http.post<any>(`/api/user/password/remind`, {username});
    }


    getCurrentUser(blocking = true) {
        const params = new InterceptorHttpParams(blocking);
        return this.http.get<SystemUser>(`/api/secured/user`, {params});
    }

    changeCharacter(entityVersion: number) {
        return this.http.post(`/api/secured/user/character/${entityVersion}`, {})
            .subscribe(() => window.location.reload());
    }

    forgotPassword(username: string) {
        return this.http.post(`/api/public/user/forgot-password`, {username})
            .pipe(catchError(this.errorsMain), tap(this.cleanMain))
    }

    resetPassword(token: string, password: string, password2: string) {
        return this.http.post(`/api/public/user/reset-password/${token}`, {password, password2})
            .pipe(catchError(this.errorsMain), tap(this.cleanMain))
    }
}
